import styled from 'styled-components';

const Report = styled.div`
  margin-top: 2rem;
`;

export default Report;
